export enum LoanAmountType {
  HomeImprovement = 'HomeImprovement',
  PointOfSale = 'PointOfSale',
  Full = 'Full',
}
